module.exports = __webpack_public_path__ + "static/media/batterysprayer.73941c31.jpg";